// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608282035/js/" + chunkId + "." + {"44":"39558ffa","225":"c8cd40e6","481":"ac7cb97c","486":"4747768c","770":"cdff4e53"}[chunkId] + ".0.5135801143717922.chunk.js";
};